import { CaretDownIcon } from '@phosphor-icons/react';
import { format, parseISO } from 'date-fns';
import { css, html } from 'react-strict-dom';
import { DropdownMenu, DropdownMenuItem, Text } from 'src/components';
import { Color, Style } from 'src/constants';
import { color } from 'src/constants/color.css';
import { formatAsDayLabel } from 'src/util';

type Props = {
  /** The days on offer, newest first, as `yyyy-MM-dd`. */
  dates: ReadonlyArray<string>;
  value: string;
  onChange: (date: string) => void;
};

/**
 * Picks which day the activity is shown for.
 */
export default function ActivityDateSelect({ dates, value, onChange }: Props) {
  return (
    <DropdownMenu
      trigger={(open) => (
        <html.button
          style={[
            Style.row,
            Style.alignCenter,
            styles.trigger,
            open && styles.triggerOpen,
          ]}
        >
          <Text typeface="body.small.medium" color="neutral100">
            {format(parseISO(value), 'EEEE d MMMM')}
          </Text>
          <CaretDownIcon size={14} color={Color.neutral60} />
        </html.button>
      )}
    >
      {(close) =>
        dates.map((date) => (
          <DropdownMenuItem
            key={date}
            showRadio={false}
            selected={date === value}
            onClick={() => {
              onChange(date);
              close();
            }}
          >
            {formatAsDayLabel(date)}
          </DropdownMenuItem>
        ))
      }
    </DropdownMenu>
  );
}

const styles = css.create({
  trigger: {
    gap: 6,
    paddingLeft: 12,
    paddingRight: 10,
    paddingBlock: 6,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: color.neutral20,
    borderRadius: 8,
    backgroundColor: color.neutral0,
    cursor: 'pointer',
    transition: 'border-color 0.15s',
    ':hover': {
      borderColor: color.neutral40,
    },
  },
  triggerOpen: {
    borderColor: color.neutral40,
  },
});
